<body class="container">
  <ion-row class="header">
    <span class="header-text">{{ CONSTS.HEADER }}</span>
  </ion-row>
  <div class="content">
    @for (
      reportRow of REPORT_BUTTON_GROUPS;
      track reportRow;
      let rowIndex = $index
    ) {
      <ion-row class="row-button-group">
        @for (
          reportGroup of reportRow;
          track reportGroup;
          let groupIndex = $index
        ) {
          <ion-col size="12" size-sm="6" size-xl="3">
            @if (roleUtils.showReportGroup(reportGroup.enum, isIDO, userRole)) {
              <app-report-button-group
                class="button-group"
                [ngClass]="{ 'ido-group': rowIndex === 1 && groupIndex === 3 }"
                [sectionHeader]="reportGroup.header"
                [buttons]="reportGroup.buttons"
                [hasAltSpacing]="reportGroup.hasAltSpacing"
                [locationIdo]="isIDO"
                [userRole]="userRole"
                (emitButtonGroupClick)="buttonGroupClick($event)"
              ></app-report-button-group>
            }
          </ion-col>
        }
      </ion-row>
    }
  </div>
</body>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="AGED_RETAIL_STATUS_PDF_REPORT.COLUMNS"
  [columnsData]="agedRetailStatusReport"
  [dataFields]="AGED_RETAIL_STATUS_PDF_REPORT.DATA_FIELDS"
  [dataRowHeight]="29"
>
  <ng-container sub-header>
    <p>Location: {{ locationCode }}</p>
  </ng-container>
</app-pdf-report-generator>
